import React from 'react';
import styles from "../styles/Discover.module.css";
import beach from "../images/corfu-beach.jpg";
import castle from "../images/corfu-castle.jpg";
import center from "../images/corfu-center.jpg";
import { useTranslation } from "react-i18next";

export default function Discover() {
  const { t } = useTranslation();

  return (
    <>

      <section className={styles.main}>

        {/* SECTION 1 */}
        <div className={styles.container}>
          <div className={styles.imageWrapper}>
            <img
              src={beach}
              alt="Corfu hidden beach"
              className={styles.image}
            />
          </div>

          <div className={styles.textWrapper}>
            <h2>{t("discover.section1.title")}</h2>
            <p>{t("discover.section1.text")}</p>
          </div>
        </div>

        {/* SECTION 2 */}
        <div className={`${styles.container} ${styles.light}`}>
          <div className={styles.textWrapper}>
            <h2>{t("discover.section2.title")}</h2>
            <p>{t("discover.section2.text")}</p>
          </div>

          <div className={styles.imageWrapper}>
            <img
              src={center}
              alt="Corfu local food"
              className={styles.image}
            />
          </div>
        </div>

        {/* SECTION 3 */}
        <div className={styles.container}>
          <div className={styles.imageWrapper}>
            <img
              src={castle}
              alt="Corfu fortress"
              className={styles.image}
            />
          </div>

          <div className={styles.textWrapper}>
            <h2>{t("discover.section3.title")}</h2>
            <p>{t("discover.section3.text")}</p>
          </div>
        </div>

      </section>

    </>
  );
}